import { createComponent, createElement, computed } from "@vue/composition-api";
import { barcodeFormatter } from "@/shared/barcodeFormatter";
import { Input } from "element-ui";

export default createComponent({
  name: "BarcodeInput",
  props: {
    value: { required: false, type: String },
  },
  setup(props, ctx) {
    const formattedValue = computed(() => barcodeFormatter(props.value || ""));

    return () =>
      createElement(Input, {
        props: {
          ...ctx.attrs,
          value: formattedValue.value,
        },
        on: {
          ...ctx.listeners,
          input: (val: string) => {
            // remove spaces from the output value
            ctx.emit("input", val.replace(/\s/g, ""));
          },
        },
      });
  },
});
